export const ALL_AGENTS_CATEGORY_ID = 'all-agents';
export const FAVOURITE_AGENTS_CATEGORY_ID = 'favourite';
export const RECOMMENDED_CATEGORY_ID = 'recommended';
export const VERIFIED_AGENTS_CATEGORY_ID = 'verified';
export const YOUR_AGENTS_CATEGORY_ID = 'your-agents';
